import type { Chain } from '../../modules/chain';
import { CHAINS_INFO_MAP } from '../../modules/wallets/constants';
import { assertDefined } from '../assertDefined';

export const getChainFromVerifiedCredentialChain = (
  verifiedCredentialChain: string
): Chain => {
  const chains = Object.keys(CHAINS_INFO_MAP) as Chain[];

  const chain = chains.find(
    (chain) =>
      CHAINS_INFO_MAP[chain].verifiedCredentialChainName ===
      verifiedCredentialChain
  );

  assertDefined(chain, `Unknown chain: ${verifiedCredentialChain}`);

  return chain;
};
